const breadCrumb = "Lotação de Servidores - Diretores e Secretários";

const routes = [
  {
    path: "/nomeacao-de-diretores-e-secretarios",
    name: "nomeacao-de-diretores-e-secretarios",
    meta: {
      allowedPermissions: ["nomeacao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/NomeacaoDeDiretoresESecretarios/NomeacaoDeDiretoresESecretariosHome.vue"
      ),
  },
  {
    path: "/nomeacao-de-diretores-e-secretarios/novo",
    name: "nomeacao-de-diretores-e-secretarios-novo",
    meta: {
      allowedPermissions: ["nomeacao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/NomeacaoDeDiretoresESecretarios/NomeacaoDeDiretoresESecretariosCad.vue"
      ),
  },
  {
    path: "/nomeacao-de-diretores-e-secretarios/consultar/:id",
    name: "nomeacao-de-diretores-e-secretarios-consultar",
    meta: {
      allowedPermissions: ["nomeacao_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/NomeacaoDeDiretoresESecretarios/NomeacaoDeDiretoresESecretariosConsultar.vue"
      ),
  },
  {
    path: "/nomeacao-de-diretores-e-secretarios/editar/:id",
    name: "nomeacao-de-diretores-e-secretarios-editar",
    meta: {
      allowedPermissions: ["nomeacao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/NomeacaoDeDiretoresESecretarios/NomeacaoDeDiretoresESecretariosEdit.vue"
      ),
  },
];

export default routes;
